// extracted by mini-css-extract-plugin
export default {"loader-container":"LoadingSpinner_loader-container__NqMlj","spinner":"LoadingSpinner_spinner__mrADT","spin":"LoadingSpinner_spin__1-BSS"};